import React from 'react'

const Main = ({ children }) => {
	return (
		<div>
			{children}
		</div>
	)
}

export default Main;
